import React from 'react'

import { HeadingSmall } from '@pb/components'

import styles from './ErrorMessage.scss'

interface ErrorMessageProps {
  title: string
}

const ErrorMessage: React.FC<ErrorMessageProps> = ({ title }) => (
  <div className={styles.container}>
    <HeadingSmall Tag="h2">{title}</HeadingSmall>
  </div>
)

export default ErrorMessage
